import { render, staticRenderFns } from "./DetailsProgress.vue?vue&type=template&id=f2765e70&scoped=true"
import script from "./DetailsProgress.vue?vue&type=script&lang=js"
export * from "./DetailsProgress.vue?vue&type=script&lang=js"
import style0 from "./DetailsProgress.vue?vue&type=style&index=0&id=f2765e70&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2765e70",
  null
  
)

export default component.exports
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTimeline,QTimelineEntry});
